module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ins', {
    staticClass: "adsbygoogle",
    style: (_vm.adStyle),
    attrs: {
      "data-ad-client": _vm.adClient,
      "data-ad-slot": _vm.adSlot,
      "data-ad-format": _vm.adFormat,
      "data-ad-layout-key": _vm.adLayoutKey
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6ccabc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/adsense.vue
// module id = 309
// module chunks = 1